<template>
  <div class="user-list">
    <el-button @click="exportScoreDetail">下载填写记录</el-button>
    <!-- <el-button type="primary" @click="exportScoreDetail">批量导入成绩</el-button> -->
    <el-button :loading="uping" style="margin-left: 20px" type="primary" @click="clickInp">批量导入成绩</el-button>
    <a
      style="margin-left: 20px"
      href="https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/train_service/app_upload/57e0e6d52d5c3f83cfe1d573feadf8ba.xlsx"
      type="primary"
      target="_blank"
      >导入模板下载</a
    >
    <input v-show="false" v-if="!uping" id="fileup" type="file" name="" value="" @change="getFile" />
    <div class="table" style="margin-top: 10px">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="uuid" label="姓名">
          <template v-if="scope.row.user" slot-scope="scope">
            {{ scope.row.user.real_name || "" }}
          </template>
        </el-table-column>
        <el-table-column prop="score" label="得分"> </el-table-column>
        <el-table-column label="邮箱" prop="join_email"> </el-table-column>
        <!-- <el-table-column prop=" " label="附件">
                    <template slot-scope="scope">
                        <el-image
                            v-if="scope.row.imgs"
                            style="width: 100px; height: 100px"
                            :src="scope.row.imgs"
                            fit="contain"
                            :preview-src-list="[scope.row.imgs]"
                        >
                        </el-image>

                        <video v-if="scope.row.videos" width="90%" height="100px" :src="scope.row.videos" controls="controls"></video>
                        <p>
                            <a :href="scope.row.thumb" download="附件"> 点击下载 </a>
                        </p>

                    </template></el-table-column> -->
        <el-table-column prop="create_time" label="填写时间"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="showScore(scope.row)">查看/打分</el-button>

            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="终考评分表" :visible.sync="lastScoreBox" width="30%" center>
      <el-form ref="lastForm" :model="lastForm" :rules="lastRule" label-width="100px" class="demo-ruleForm">
        <el-form-item label="个人品质" prop="person_quality">
          <el-input v-model="lastForm.person_quality"></el-input>
        </el-form-item>
        <el-form-item label="课堂纪律" prop="class_discipline">
          <el-input v-model="lastForm.class_discipline"></el-input>
        </el-form-item>
        <el-form-item label="行为举止" prop="person_behavior">
          <el-input v-model="lastForm.person_behavior"></el-input>
        </el-form-item>
        <el-form-item label="实操成绩" prop="real_score">
          <el-input v-model="lastForm.real_score"></el-input>
        </el-form-item>
        <el-form-item label-width="0" style="text-align: center">
          <el-button type="primary" @click="showVideo(1)">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="日常考试评分表" :visible.sync="dailyBox" width="30%" center>
      <el-form ref="dailyForm" :model="dailyForm" :rules="dailyRule" label-width="100px" class="demo-ruleForm">
        <el-form-item label="完成项目数" prop="finish_item">
          <el-input v-model="dailyForm.finish_item"></el-input>
        </el-form-item>
        <el-form-item label="评分" prop="daily_score">
          <el-input v-model="dailyForm.daily_score"></el-input>
        </el-form-item>
        <el-form-item label="评分老师" prop="daily_teacher">
          <el-input v-model="dailyForm.daily_teacher"></el-input>
        </el-form-item>

        <el-form-item label-width="0" style="text-align: center">
          <el-button type="primary" @click="subDaily">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="打分宣誓" :visible.sync="vowBox" width="30%" center>
      <div style="text-align: center">
        为确保考试打分公平公正,请打分老师在打分前上传宣誓视频. 宣誓内容如下:本人{{ username }},保证打分公平公正
        <imgUploads v-model="video" source-type="1" style="margin: 20px 0"> </imgUploads>
        <el-button type="primary" @click="lastSub">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  TotalScore,
  TotalScoreDetail,
  offLineScore,
  offLineScoreDetail,
  delScoreDetail,
  exportScoreDetail,
  UserScoreImport,
} from "@/api/edu.js";
import { getTeacherList } from "@/api/teacher.js";
import { mixin } from "@/mixins/pagination.js";
import imgUploads from "@/components/pub/supperUpload.vue";
import Utils from "@/jslibs/utils";
export default {
  components: {
    imgUploads,
  },
  mixins: [mixin],
  data() {
    return {
      vowBox: false,
      video: [],
      actrow: {},
      username: Utils.getCookie("X-Access-Name"),
      lastScoreBox: false,
      lastForm: {},
      lastRule: {
        real_score: [
          {
            required: true,
            message: "请输入实操成绩",
            trigger: "blur",
          },
        ],
        person_behavior: [
          {
            required: true,
            message: "请输入行为举止",
            trigger: "blur",
          },
        ],
        class_discipline: [
          {
            required: true,
            message: "请输入课堂纪律",
            trigger: "blur",
          },
        ],
        person_quality: [
          {
            required: true,
            message: "请输入个人品质",
            trigger: "blur",
          },
        ],
      },
      dailyForm: {},
      dailyRule: {
        daily_teacher: [
          {
            required: true,
            message: "请输入评分老师",
            trigger: "blur",
          },
        ],
        daily_score: [
          {
            required: true,
            message: "请输入试题得分",
            trigger: "blur",
          },
        ],
        finish_item: [
          {
            required: true,
            message: "请输入完成项目数",
            trigger: "blur",
          },
        ],
      },
      dailyBox: false,
      loading: false,
      teacherList: [],
      searchParam: {},
      subType: "",
      tableData: [],
      uping: false,
    };
  },
  mounted() {
    this.getList();
    this.getTeacher("");
  },
  methods: {
    clickInp() {
      document.getElementById("fileup").click();
    },
    getFile(e) {
      console.log(e.target.files[0]);
      console.log(this.actrow.paper_uuid);
      const self = this;
      if (e && e.target.files) {
        const fd = new FormData();
        fd.append("file", e.target.files[0]);
        fd.append("paper_id", this.$route.query.paper_id);
        this.uping = true;
        UserScoreImport(fd)
          .then((res) => {
            self.uping = false;
            self.$message.success("上传成功");
            self.getList();
            // if (res instanceof Array) {
            //     this.selects.push(...res)
            // }
          })
          .catch((err) => {
            self.uping = false;
            self.$message.error("上传出错");
          });
      }
      // console.log(file)
    },
    lastSub() {
      this.vowBox = false;
      if (this.subType == 1) {
        this.confirmFinal();
      } else if (this.subType == 2) {
        this.subDaily();
      }
    },
    showVideo(type) {
      this.subType = type;
      this.vowBox = true;
    },
    confirmFinal() {
      if (this.video.length == 0) {
        this.$message.warning("请上传视频");
        return;
      }
      this.$refs["lastForm"].validate((valid) => {
        offLineScore({
          paper_uuid: this.actrow.paper_uuid,
          user_uuid: this.actrow.user_uuid,
          ...this.lastForm,
          total_uuid: this.actrow.uuid,
          score_video: this.video[0],
        }).then((res) => {
          if (res == true) {
            this.$message.success("成功");
            this.getList();
            this.lastScoreBox = false;
          }
        });
      });
    },
    subDaily() {
      this.$refs["dailyForm"].validate((valid) => {
        offLineScore({
          paper_uuid: this.actrow.paper_uuid,
          user_uuid: this.actrow.user_uuid,
          total_uuid: this.actrow.uuid,
          ...this.dailyForm,
        }).then((res) => {
          if (res == true) {
            this.$message.success("成功");
            this.getList();
            this.dailyBox = false;
          }
        });
      });
    },
    getScoreDetail(uuid, type) {
      offLineScoreDetail(uuid).then((res) => {
        if (res) {
          if (type == 1) {
            this.dailyForm = res;
          } else {
            if (res.score_video) {
              this.video = [res.score_video];
            }
            this.lastForm = res;
          }
        }
      });
    },
    showScore(row) {
      this.actrow = row;

      if (this.$route.query.paper_type == 1) {
        // 日常
        this.dailyForm = {};
        this.dailyBox = true;
        this.getScoreDetail(row.uuid, 1);
      } else {
        // 终考
        this.lastForm = {};
        this.lastScoreBox = true;
        this.getScoreDetail(row.uuid, 2);
      }
    },
    showRecordDetail(row) {
      TotalScoreDetail(row.uuid);
    },
    getTeacher(keyword_search) {
      getTeacherList({ keyword_search }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    toAdd() {
      console.log(row);
      this.$router.push({
        path: "/offline-detail",
        query: row,
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/offline-add",
        query: row,
      });
    },

    setTop(row) {},
    xiajia(row) {},
    deleteItem(row) {
      this.$confirm("确定要删除该记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delScoreDetail(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    exportScoreDetail() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        paper_uuid: this.$route.query.uuid,
      };
      exportScoreDetail(param);
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        paper_uuid: this.$route.query.paper_id,
      };
      this.loading = true;
      const res = await TotalScore(param);
      this.loading = false;
      const video = ["mp4", "flv"];
      const img = ["png", "jpg", "jpeg"];
      if (res.data instanceof Array) {
        this.tableData = res.data.map((it) => {
          if (it.thumb) {
            const substr = it.thumb.split(".");
            const last = substr[substr.length - 1];
            if (video.indexOf(last.toLowerCase()) >= 0) {
              it.videos = it.thumb;
            } else if (img.indexOf(last.toLowerCase()) >= 0) {
              it.imgs = it.thumb;
            } else {
              it.texts = it.thumb;
            }
          }
          return it;
        });
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
